var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center my-5 text-danger font-weight-bolder"},[_vm._v(" "+_vm._s(_vm.$t('notification.incorrect_domain'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }